import React from "react";

export default ({ text }) => (
  <li className="nk-menu-heading">
    <h6 className="overline-title">{text}</h6>
  </li>
);